import { createContext } from 'react';

export type Appearance = 'inherit' | 'light' | 'dark';

export type ThemeContextValue = {
    appearance: Appearance;
    isRoot: boolean;
    setAppearance?: (appearance: Appearance) => void;
};

export const ThemeContext = createContext<ThemeContextValue>({
    appearance: 'inherit',
    isRoot: true,
});
